import React, { useCallback, useRef } from 'react';
import { useKeyboardShortcuts } from '@fiverr-private/hooks';
import { CloseButton } from '@fiverr-private/button';
import { useModalContext } from '../ModalContext';
import { ModalCloseBtnProps } from '../types';
import { MODAL_CLOSE_BTN_ID } from '../constants';

const ModalCloseBtn = ({ onClick, color = 'dark' }: ModalCloseBtnProps) => {
  const { close } = useModalContext();
  const ref = useRef(null);
  const getTarget = useCallback(() => ref.current, [ref]);

  const onTrigger = () => {
    onClick?.();
    close();
  };

  useKeyboardShortcuts(
    [
      {
        trigger: 'enter',
        handler: onTrigger,
      },
      {
        trigger: 'space',
        handler: onTrigger,
      },
    ],
    getTarget
  );

  return <CloseButton ref={ref} size="md" color={color} onClick={onTrigger} />;
};

ModalCloseBtn.displayName = 'ModalCloseBtn';

Object.assign(ModalCloseBtn, {
  id: MODAL_CLOSE_BTN_ID,
});

export default ModalCloseBtn;
